import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('a-result', {
    attrs: {
      "title": _vm.t('请等待...')
    }
  })], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };